import React from 'react';
import { ThemeProvider } from 'fronton-react';
import { RecoilRoot } from 'recoil';
import { ProjectConfigurationPage } from 'pages/project-configuration';
import { Fallback } from 'pages/fallback/fallback';
import { ErrorBoundary } from '../../error-boundary';
import { TData } from './context';

export type ProjectConfigurationProps = TData;
export type ProjectConfigurationState = TData;

export const ProjectConfiguration: React.FC<TData> = data => {
  if (!data.regionId) {
    return null;
  }

  return (
    <ThemeProvider>
      <ErrorBoundary
        fallback={
          <Fallback
            title="Ой, что-то пошло не так..."
            description="Попробуйте обновить страницу"
            buttonText="Обновить страницу"
          />
        }>
        <RecoilRoot>
          <ProjectConfigurationPage data={data} />
        </RecoilRoot>
      </ErrorBoundary>
    </ThemeProvider>
  );
};
